const waitUntil = (check: () => boolean, time: number, maxCount?: number) =>
  new Promise((resolve, reject) => {
    let interval = null
    let count = 0

    const checkIfPresent = () => {
      if (check()) {
        clearInterval(interval)
        resolve()
      } else if (maxCount !== undefined && count >= maxCount) {
        clearInterval(interval)
        reject()
      } else {
        count += 1
      }
    }

    interval = setInterval(checkIfPresent, time)
  })

export { waitUntil }
